export const mainColor = {
  red: 0,
  green: 153,
  blue: 115,
  hexa: '#009973',
  secondaryColor: '#009973',
  drawer: '#083628',
  rgb: '0, 153, 115',
  iconColor: '#b1c3c8',
  colorWhite: 'rgba(255, 255, 255, 1)',
  colorWhiteLight: 'rgba(255, 255, 255, 0)',
  colorAccent: '#009973',
  colorAdditional: '#999999',
  colorYellow: '#f6da6e',
  colorPurple: '#c88ffa',
  colorRed: '#ff4861',
  colorBlue: '#70bbfd',
  colorGray: '#e7e2e2',
  colorDarkGray: '#646777',
  colorGreen: '#4ce1b6',
  colorBrown: '#A0522D',
  colorClearGray: '#0000008a',
  colorBlack: '#000000',
  colorBlackLight: 'rgba(0,0,0, 0.65)',
  colorMediumGray: '#dcdcdc40',
  backGroundColor: '#F2F4F7'
};
export const backColor = {
  'En préparation': `255, 180, 0`,
  'En attente': `255, 0, 0`,
  'En livraison': `11, 194, 45`,
  'Prête à être emportée': `11, 194, 45`,
  'En attente du serveur': `11, 194, 45`,
  'En recherche de livreurs': `13, 164, 225`,
  Terminée: '255,255,255',
  Annulée: '255,255,255',
  Manquée: '255,255,255',
  Refusée: '255,255,255'
};
export const mainMargin = {
  margin: '40px 40px 40px 40px'
};

export const BORDER_RADIUS = 16;
export const UNIT = 16;
export const BLACK = 'black';
export const ZONE_OPTIONS = {
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillOpacity: 0.2,
  visible: true,
  zIndex: 1
};
